package pl.decks.personal.components.animations

import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.silk.style.animation.Keyframes
import org.jetbrains.compose.web.css.percent

object SlideFromTopAnimation {
    object Vars {
        val from by StyleVariable((-100).percent)
        val to by StyleVariable(0.percent)
    }

    val Frames = Keyframes {
        from { Modifier.translateY(Vars.from.value()) }
        to { Modifier.translateY(Vars.to.value()) }
    }
}
